import type {SyntheticEvent} from 'react';

/**
 * Stop event propagation
 * @param event Event
 * @param args Arguments
 *
 * @example
 * ```ts
 * stopPropagation(event);
 * ```
 */
export const stopPropagation = <E extends SyntheticEvent | Event>(event: E) => {
	event.stopPropagation();
	event.preventDefault();
};

export default stopPropagation;
